import React from "react"
export function PlusOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm.75 2.757V9.25h3.493v1.5H10.75v3.493h-1.5V10.75H5.757v-1.5H9.25V5.757h1.5z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__plus---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
